<div class="page-wrapper">
    <mat-card class="centered-card">
        <mat-toolbar class="justify-content-center" color="primary">{{pageTitle}}</mat-toolbar>
        <form class="p-3">
            <div class="d-flex justify-content-center">
                <mat-form-field style="width: 300px;">
                    <mat-label>What is your email address</mat-label>
                    <input matInput required [(ngModel)]="email" type="email" name="email" ngModel email>
                </mat-form-field>
            </div>
            <div class="d-flex justify-content-center">
                <button class="m-2" mat-raised-button type="submit" color="primary"
                    (click)="sendCodeForVerification()">Continue</button>
            </div>
        </form>
    </mat-card>
</div>